<div *ngIf="error" class="layout-row">
    <div class="spinnerPadding">{{errorMsg}}</div>
</div>
<busy-notice
    [isBusy]="this.isBusy"
    [busyText]="this.busyText" 
    headerText="KANSO">
</busy-notice>

<button *ngIf="!posted" class="glyphicon glyphicon-new-window glyphicon-popover currencyColor"[disabled]="posted" (click)="confirmPopup()" id="cancelButton"></button>
<div *ngIf="posted" class="currencyColor" id="cancelButton"> Exported</div>
